import React, { useEffect, useState } from "react"
import { change, Field, formValueSelector, isDirty, reset } from "redux-form"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { CustomRadioField } from "components/RenderInput"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import PhonePreview from "./phonePreview"
import { updateListScreenSetup } from "store/actions"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import BottomNavigation from "components/BottomNavigation"

const LayoutTab = ({
  categoriesToggle,
  layout,
  change,
  isDirty,
  tabIsActive,
  resetForm,
  listScreenSetup,
  updateListScreenSetup,
  handleNext,
  handleBack,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)
  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  useEffect(() => {
    if (categoriesToggle && (layout === "2" || layout === "4")) {
      change("layout.layout", "3")
    }
  }, [categoriesToggle])

  const onSave = () => {
    updateListScreenSetup({
      values: {
        ...listScreenSetup,
        template_id: layout,
      },
    })
  }

  return (
    <React.Fragment>
      <Row className="mt-3">
        <Col xl={8}>
          <Card>
            <CardHeader>
              <h4>Select Layout</h4>
            </CardHeader>
            <CardBody>
              <Row>
                <Col xs={12} className="d-flex">
                  <Row>
                    {!categoriesToggle && (
                      <Col>
                        <Field
                          name="layout"
                          value={"2"}
                          label="Cards"
                          type="radio"
                          component={CustomRadioField}
                          img="https://admin.dev.markedprivate.com/app/images/templates/list_screen_template2.png"
                        />
                      </Col>
                    )}
                    <Col className="mx-3">
                      <Field
                        name="layout"
                        value={"3"}
                        label="Boxes"
                        type="radio"
                        component={CustomRadioField}
                        img="https://admin.dev.markedprivate.com/app/images/templates/list_screen_template3.png"
                      />
                    </Col>
                    {!categoriesToggle && (
                      <Col className="mx-3">
                        <Field
                          name="layout"
                          value={"4"}
                          label="Carousel"
                          type="radio"
                          component={CustomRadioField}
                          img="https://admin.dev.markedprivate.com/app/images/templates/list_screen_template4.png"
                        />
                      </Col>
                    )}
                    <Col className="mx-3">
                      <Field
                        name="layout"
                        value={"5"}
                        label="Grid"
                        type="radio"
                        component={CustomRadioField}
                        img="https://admin.dev.markedprivate.com/app/images/templates/list_screen_template5.png"
                      />
                    </Col>
                    <Col className="mx-3">
                      <Field
                        name="layout"
                        value={"6"}
                        label="Simple Stack"
                        type="radio"
                        component={CustomRadioField}
                        img="	https://admin.dev.markedprivate.com/app/images/templates/list_screen_template6.png"
                      />
                    </Col>
                    <Col className="mx-3">
                      <Field
                        name="layout"
                        value={"8"}
                        label="Circles"
                        type="radio"
                        component={CustomRadioField}
                        img="https://admin.dev.markedprivate.com/app/images/templates/list_screen_template8.png"
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <BottomNavigation
            handleBack={handleBack}
            handleNext={handleNext}
            handleSave={onSave}
          />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <PhonePreview />
        </Col>
      </Row>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          onSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const selector = formValueSelector(FORM_NAMES.LIST_SCREEN)

const mapStateToProps = state => ({
  categoriesToggle: selector(state, "categories.categoriesToggle"),
  layout: selector(state, "layout.layout"),
  isDirty: isDirty(FORM_NAMES.LIST_SCREEN)(state, ...["layout"]),
  listScreenSetup: state.ListScreen.listScreenSetup,
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) =>
    dispatch(change(FORM_NAMES.LIST_SCREEN, `${field}`, value)),
  resetForm: () => dispatch(reset(FORM_NAMES.LIST_SCREEN)),
  updateListScreenSetup: values => dispatch(updateListScreenSetup(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(LayoutTab)
